module.exports = __webpack_public_path__ + "img/not_in_period.e6f5ebe0.png";